export const fetchAllLevels = {
  display: 'Play Tags',
  name: 'Fetch_Tags',
  function: 'levels',
  return: ['id', 'name']
};
